/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {Box, ClickAwayListener, IconButton, Popper} from "@mui/material";
import { baseBlue } from "../../../constants/colors";

export default function ArgosPopper(props: any) {
  const modifiers = [
    {
      name: 'offset',
      options: {
        offset: ({placement, reference, popper}: any) => {
          return [0, 10]
        },
      },
    },
  ]
  
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const buttonRef = React.useRef<HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setOpen((prev) => !prev)
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  // Clone IconButton to inject ref and onClick
  const button = React.cloneElement(props.button, {
    ref: buttonRef,
    onClick: handleClick,
  });

    // If tooltip is provided, clone it and inject the button as its child
  const buttonWithTooltip = props.tooltip
    ? React.cloneElement(props.tooltip, {}, button)
    : button;

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <span>{buttonWithTooltip}</span>
      </ClickAwayListener>
      <Popper open={open} anchorEl={anchorEl} style={{zIndex: 100000}}
              popperOptions={{placement: 'bottom-start', modifiers: modifiers}} keepMounted={true}>
        <Box sx={{border: 1, p: 1, color: baseBlue, bgcolor: 'background.paper'}}>
          {props?.children}
        </Box>
      </Popper>
    </>
  );
}
